import { user } from 'services/user';
import { LangSelector } from 'libs/ui';
import { DesignSwitch } from '../page-main/blocks/design-switch';
import { LoginForm } from './forms/login-form';
import { Content } from './page-auth.styled.classic';

export const PageAuth = () => {
  /**
   * user login
   * @param {*} values
   * @returns
   */
  const actionLogin = async (data, helpers) => {
    await user.login(data).catch((errors) => {
      helpers.setErrors({ api: errors });
    });
  };

  return (
    <Content>
      <img height="100" src="/images/auth-logo.png" alt="" />
      <LangSelector />
      <LoginForm onSubmit={actionLogin} />
      <div style={{ marginTop: 32 }}>
        <DesignSwitch />
      </div>
    </Content>
  );
};
